module.exports = "/site/themes/rkt/_/buckleys/node_modules/@fortawesome/fontawesome-pro/webfonts/fa-regular-400.ttf";


//////////////////
// WEBPACK FOOTER
// ../~/@fortawesome/fontawesome-pro/webfonts/fa-regular-400.ttf
// module id = 71
// module chunks = 3